import { MutationTree, Mutation } from 'vuex'

import {
  SET_AUTH,
  SET_CUSTOMERS_LIST,
  SET_CUSTOMER,
  CLEAR_AUTH
} from '@/system/store/mutation-types'

import {
  IAuthStore,
  IAuthData,
  IUser,
  ICustomer,
  state as emptyState
} from '@/features/auth/store'

const setAuth: Mutation<IAuthStore> = (state: IAuthStore, { expiresAt, token, user }: IAuthData & { user: IUser }) => {
  state.expiresAt = expiresAt
  state.token = token
  state.user = user
  return state
}

const setCustomers: Mutation<IAuthStore> = (state: IAuthStore, customers: ICustomer[]) => {
  state.customers = [...customers]
  return state
}

const setCustomer: Mutation<IAuthStore> = (state: IAuthStore, customer: ICustomer) => {
  state.selectedCustomer = { ...customer }
  return state
}

const clearAuth: Mutation<IAuthStore> = (state: IAuthStore) => {
  return Object.assign(state, emptyState)
}

const mutations: MutationTree<IAuthStore> = {
  [SET_AUTH]: setAuth,
  [SET_CUSTOMERS_LIST]: setCustomers,
  [SET_CUSTOMER]: setCustomer,
  [CLEAR_AUTH]: clearAuth
}

export default mutations
